<template>
  <v-container class="pa-0">
    <v-sheet color="#e0f6ff77" class="pa-2" :style="'overflow: auto'">
      <app-pagination
        ref="pag"
        :getter="source"
        :params="{ limit: 5 }"
        table
        header
        :tableHeader="tableHeader"
        @edit="$emit('edit', $event)"
        @switch="$emit('switch', $event)"
        @activeChanged="$emit('activeChanged', $event)"
        @remove="$emit('remove', $event)"
      />
    </v-sheet>
    <v-dialog v-model="dialog" width="unset" v-if="post">
      <template v-slot:activator="{ on }">
        <v-row justify="end" class="my-4">
          <v-btn color="#FF347C" depressed class="white--text mr-4" v-on="on">Create</v-btn>
        </v-row>
      </template>
      <v-card width="70vw" class="px-6 pb-2">
        <v-card-title class="headline" style="color: #ff347c">
          <slot name="title">Create</slot>
        </v-card-title>
        <v-form ref="form" v-model="form" @submit.prevent @keydown.enter="submit">
          <slot name="form"></slot>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            color="#FF347C"
            @click.prevent="submit"
            depressed
            class="white--text"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
/* eslint-disable no-console */
import Pagination from "./../Pagination";

export default {
  components: {
    appPagination: Pagination,
  },
  props: {
    source: {
      type: Function,
      required: true,
    },
    post: {
      type: Function,
      required: false,
    },
    tableHeader: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
      form: false,
      key: 0,
      loading: false,
    };
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      try {
        const form = {};
        this.$refs.form.inputs.forEach((element) => {
          form[element.id] = element.value;
        });
        const response = await this.post(form);
        if (response.status === 201) {
          this.$refs.pag.addResult(response.data);
        }
        this.dialog = false;
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    },
  },
};
</script>
